import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { environment } from '../../../environments/environment'

@Injectable({
	providedIn: 'root',
})
export class WalletTransferService {
	constructor(private readonly httpClient: HttpClient) {}

	/**
	 * Transfer funds between wallets
	 */
	transferFunds(
		from: 'exchange' | 'casino',
		to: 'exchange' | 'casino',
		amount: number,
	): Observable<{ status?: string; success?: boolean; message?: string }> {
		const transferType = from === 'exchange' ? 'main_to_secondary' : 'secondary_to_main'
		const body = {
			AMOUNT: amount.toString(),
			TRANSFER_TYPE: transferType,
		}

		return this.httpClient.post<{ status?: string; success?: boolean; message?: string }>(`${environment.apiUrl}/api/wallet/internal-transfer`, body)
	}
}
